import { Button, alpha } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { orange } from "../../themes/colors";
export default withStyles(theme => {
    const isDark2 = theme.palette.background.default === '#202326';
    const orangeColor = isDark2
        ? { main: '#98713f', dark: '#795a32', contrastText: '#ffffff' }
        : orange;

    return {
        text: {
            color: orangeColor.main,
            '&:hover': {
                backgroundColor: alpha(orangeColor.main, theme.palette.action.hoverOpacity),
            }
        },
        outlined: {
            color: orangeColor.main,
            border: `1px solid ${alpha(orangeColor.main, 0.5)}`,
            '&:hover': {
                border: `1px solid ${orangeColor.main}`,
                backgroundColor: alpha(orangeColor.main, theme.palette.action.hoverOpacity),
            }
        },
        contained: {
            color: orangeColor.contrastText,
            backgroundColor: orangeColor.main,
            '&:hover': {
                backgroundColor: orangeColor.dark
            },
            '&:disabled': {
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                color: '#999999'
            },
        }
    };
}, { name: 'MuiButton-Orange' })(Button);